import {useState} from 'react';
import Header from '../../../shared/Header';
import {Box, Flex, Stack} from '../../../shared/layouts';
import {useTheme} from '@emotion/react';
import {useMediaQuery} from '@dnhb/node_package';
import Card from '../../../shared/Card';
import Button from '../../../shared/Button';
import {useTranslation} from 'react-i18next';
import ScanQrIcon from 'imagesUwKluis/svg/scan_qr.svg';
import DownloadIcon from 'imagesUwKluis/svg/download_big.svg';
import {AppleIcon, ClickableDownloadIcons, GoogleIcon} from '../../../shared/DownloadAppModal';

const QrScanningSection = ({
  sourceType,
  setShowDownloadAppModal,
  isFetching,
  refetch,
  url,
  qr,
  type
}) => {
  return (
    <>
      <SourceDataQrSection
        sourceType={sourceType}
        isFetching={isFetching}
        refetch={refetch}
        url={url}
        qr={qr}
        setShowDownloadAppModal={setShowDownloadAppModal}
        type={type}
      />
      {type === 'veiligophalen' && (
        <DownloadAppSection
          sourceType={sourceType}
          setShowDownloadAppModal={setShowDownloadAppModal}
        />
      )}
    </>
  );
};

const SourceDataQrSection = ({ sourceType, isFetching, refetch, url, qr, type }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const [forceShowQr, setForceShowQr] = useState(false);
  const showQr = isMinDesktop || forceShowQr;
  const { app_name, logo } = sourceType;

  return (
    <Card>
      <Stack space={'m'}>
        <Header
          icon={<ScanQrIcon />}
          button={isMinDesktop && logo}
          title={t('Brondataverzoek')}
          variant="section"
          width={'100%'}
        />
        <Flex
          minWidth={'100%'}
          flexDirection={{ mobile: 'column', desktop: 'row' }}
          justifyContent={'space-between'}
          css={{ gap: isMinDesktop ? '40px' : null, '> *': { flex: '1 0 40%' }}}
        >
          <Box>
            <strong>{t('Laten we beginnen!')}</strong>
            <br />
            <strong>{t('Dit heb je nodig:')}</strong>
            <br />
            <ul css={{ listStyle: 'disc' }}>
              <li>{t('Je hebt DigiD inloggegevens met SMS-controle.')}</li>
              <li>{t('Je hebt minstens 1x ingelogd op MijnOverheid.nl.')}</li>
            </ul>
            <p>
              {t(
                'Scan de QR-code met de camera van je telefoon of direct in de {{app_name}} app.',
                { app_name }
              )}
            </p>
          </Box>
          <Stack
            marginTop={{ mobile: 'm', desktop: 'l' }}
            alignItems={'center'}
            space={'m'}
          >
            {!isMinDesktop && (
              <>
                <Button
                  disabled={isFetching}
                  width={'100%'}
                  onClick={() => window.open(url)}
                >
                  {t('Open de {{app_name}} app', { app_name })}
                </Button>
                <Button
                  onClick={() => setForceShowQr(value => !value)}
                  variant={'secondary-outline'}
                  width={'100%'}
                  buttonSize={'small'}
                >
                  {forceShowQr ? t('Verberg QR code') : t('Toon QR code')}
                </Button>
              </>
            )}
            {showQr && (
              <img
                src={'data:image/png;base64,' + qr}
                alt={t('{{app_name}} qr code', { app_name })}
                width={ type === 'veiligophalen' ? '299' : '172'}
                height={ type === 'veiligophalen' ? '299' : '172'}
                style={{
                  opacity: !isFetching ? '1' : '0.1',
                  filter: !isFetching ? '' : 'blur(2px)'
                }}
              />
            )}
            <Button
              onClick={() => refetch()}
              buttonSize={'small'}
              variant={isMinDesktop ? 'primary' : 'primary-outline'}
              width={!isMinDesktop ? '100%' : null}
              disabled={isFetching}
            >
              {t('Nieuwe link')}
            </Button>
          </Stack>
        </Flex>
      </Stack>
    </Card>
  );
};

const DownloadAppSection = ({ sourceType, setShowDownloadAppModal }) => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  return (
    <Card>
      <Stack space={'s'}>
        <Header
          icon={<DownloadIcon />}
          button={sourceType.logo}
          title={t('Heb je de {{app_name}} app nog niet?', {
            app_name: sourceType.app_name
          })}
          variant="section"
          width={'100%'}
        />
        <p>
          {isMinDesktop
            ? t(
                'Installeer de app dan eerst op je mobiel. Klik op één van de buttons voor een QR-code om de app direct te installeren op je mobiel.'
              )
            : t(
                'Installeer de app dan eerst op je mobiel. Klik op één van de buttons om de app direct te installeren op je mobiel.'
              )}
        </p>
        <div style={{ display: 'flex-row' }}>
          {isMinDesktop ? (
            <>
              <div
                style={{
                  display: 'inline-block',
                  overflow: 'visible',
                  cursor: 'pointer'
                }}
              >
                <GoogleIcon onClick={() => setShowDownloadAppModal(true)} />
              </div>
              <div
                style={{
                  display: 'inline-block',
                  overflow: 'hidden',
                  cursor: 'pointer'
                }}
              >
                <AppleIcon onClick={() => setShowDownloadAppModal(true)} />
              </div>
            </>
          ) : (
            <ClickableDownloadIcons appInfo={sourceType} />
          )}
        </div>
      </Stack>
    </Card>
  );
};

export default QrScanningSection;
